import { PLPSearchParams } from "./types";

// Params that only carry client state and must stay out of a crawlable link
const PAGINATION_IGNORED_PARAMS = ["lp", "limit", "_rsc"];

// Rebuilds the current query string for another page of the same list. The
// active filters are kept so the link lands on the list the shopper is looking
// at, and page=1 is dropped so the first page keeps the bare address its
// canonical already points at.
export function buildPageHref(pathname: string, visibleSearchParams: PLPSearchParams, targetPage: number) {
	const params = new URLSearchParams();
	Object.entries(visibleSearchParams).forEach(([name, value]) => {
		if (value === undefined || value === null || value === "") return;
		if (name === "page" || PAGINATION_IGNORED_PARAMS.includes(name)) return;

		if (Array.isArray(value)) value.forEach((item) => params.append(name, String(item)));
		else params.append(name, String(value));
	});

	if (targetPage > 1) params.set("page", String(targetPage));

	const query = params.toString();
	return pathname + (query ? "?" + query : "");
}
